var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modify-apply-block',{ref:"train_p",attrs:{"data-type":"train","getEdit":_vm.getEdit,"saveEdit":_vm.saveEdit,"addEdit":_vm.addEdit,"form-parms-add":_vm.formParmsAdd,"dataFileParm":{docName: '培训与进修信息', isDoc: true},"onChange":_vm.onFormChange,"getTitle":_vm.getTitle,"block-name":"培训与进修信息","ref-name":"train","worker-id":_vm.workerId}})
}
var staticRenderFns = []

export { render, staticRenderFns }